import { registerSW } from 'virtual:pwa-register'
registerSW()

import Lightbox from './modules/Lightbox'
Lightbox()

window.addEventListener('load', () => import('./livewire'), { once: true })
